import { Navigate } from "react-router-dom";
import api from "../config/api";
import { useEffect, useState } from "react";
import Lottie from "lottie-react";
import loadingAnimation from "../lottie/loading.json";

function ProtectedRouteLoader() {
  return (
    <div className="page-wrapper">
      <div className="main-wrapper yellow-bg">
        <div className="frame-outer">
          <span className="frame-corner tl" />
          <span className="frame-corner tr" />
          <span className="frame-corner bl" />
          <span className="frame-corner br" />
          <div className="frame-border-outer">
            <div className="frame-border">
              <div className="frame-border-inner">
                <div className="frame-canvas">
                  {/* <img
                    className="frame-bg-image"
                    src="assets/images/star-bg.png"
                    alt=""
                  /> */}
                  <div
                    className="frame-content"
                  >
                    {/* <Lottie animationData={loadingAnimation} loop /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function ProtectedRoute({ children }) {
  const [status, setStatus] = useState(null); // null=loading, true=auth, false=unauth

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await api.get("/user/check-auth", { withCredentials: true });
        setStatus(res.data.loggedIn ? true : false);
      } catch {
        setStatus(false);
      }
    };
    checkAuth();
  }, []);

  if (status === null) return <ProtectedRouteLoader />;
  if (status === false) return <Navigate to="/login" replace />;
  return children;
}
